import { CheckinEntry, S3CheckinEntry } from '../../../app/types'
import { convertToCheckinEntry } from '../hooks/useCheckinDataColumns'

export function useTeam(teamEntries: S3CheckinEntry[]): CheckinEntry | undefined {
  const team = teamEntries?.find(x => x.entry_type === 'TEAM')
  return team ? convertToCheckinEntry(team) : undefined
}
